<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="rSSuggestions"
        @select="select"
        @select-all="select">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editRSSuggestions.open(0)">新建</el-button>
        <el-button type="danger" @click="deleteIds">批量删除</el-button>
        <el-upload
            :action="uploadUrl"
            :before-upload="beforeAvatarUpload"
            :disabled="disabled"
            :on-error="handlerError"
            :on-exceed="onExceed"
            :on-progress="onProgress"
            :on-success="handleSuccess"
            :show-file-list="false"
            accept=".xlsx"
            style="display: inline-block;margin-right: 5px;margin-left: 5px">
          <el-button :loading="importLoading" type="primary">导入</el-button>
        </el-upload>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="建议人">
            <el-input v-model.trim="filter.proposer" clearable/>
          </vm-search>
          <vm-search label="建议人工号">
            <el-input v-model.trim="filter.proposerNo" clearable/>
          </vm-search>
          <vm-search label="建议人部门">
            <el-input v-model.trim="filter.department" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="40"/>
      <el-table-column prop="proposer" align="center" label="建议人"/>
      <el-table-column prop="proposerNo" align="center" label="建议人工号"/>
      <el-table-column prop="department" align="center" label="建议人部门"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px">
        <template slot-scope="scope">
          <el-button type="info" @click="$refs.editRSSuggestions.open(scope.row)">编辑</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <r-s-suggestions-edit ref="editRSSuggestions" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import RSSuggestionsEdit from "@/views/information/RSSuggestions/RSSuggestionsEdit";
  export default {
    name: "RSSuggestionsList",
    components: {RSSuggestionsEdit, VmTable,VmSearch},
    data() {
      return {
        exportLoading: false,
        disabled: false,
        importLoading: false,
        idList:[],
        uploadUrl: window.config.basicServerHttpUrl + "rSSuggestions/importExcel",
        filter: {
          proposer: "",
          proposerNo: "",
          department: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
      downloadExcel() {
        window.open("/file/设备导入模板.xlsx");
      },
      select(selection) {
        this.idList = selection;
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.pkid);
          }
          this.$http
            .delete("basic","/rSSuggestions/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","rSSuggestions",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","rSSuggestions/export", this.filter)
          .then(res => {
           // console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style scoped>

</style>
